import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { userSchema } from "../user";

export const aiWalletSchema = z.object({
  id: z.string(),
  userId: z.string(),
  balance: z.number().describe("Solde en points IA (centièmes)"),
  totalPurchased: z.number(),
  totalGranted: z.number(),
  totalConsumed: z.number(),
  version: z.number(),
  user: userSchema.optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export class AiWalletDto extends createZodDto(aiWalletSchema) {}
